import React from "react";
import PropTypes from "prop-types";
import "./support-banner.m.css";

const DonationCard = ({
  imageSrc,
  altText,
  title,
  description,
  additionalText,
  buttonLink,
  buttonText,
  showButton = true
}) => (
  <div styleName="support-banner">
    <img styleName="support-image" src={imageSrc} alt={altText} />
    <span styleName="support-title">{title}</span>
    <div styleName="text-wrap">
      <span styleName="support-title-text">{description}</span>
      {additionalText && <span styleName="bottom-text-gray">{additionalText}</span>}
    </div>
    {showButton && (
      <a href={buttonLink} target="_blank" rel="noopener noreferrer" styleName="anchor">
        <button styleName="support-donate-button">{buttonText}</button>
      </a>
    )}
  </div>
);

DonationCard.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  additionalText: PropTypes.string,
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
  showButton: PropTypes.bool
};

DonationCard.defaultProps = {
  buttonText: "DONATE",
  buttonLink: "#",
  additionalText: "",
  showButton: true
};

const SupportBanner = ({ sectionData }) => {
  const { paymentLinks = [], photos = [] } = sectionData || {};

  const donationCards = [
    {
      imageSrc: photos[0],
      altText: "SEC 80(G)",
      title: "SEC 80(G)",
      description: "Indian residents and organisations, 50% of donated amount can be deducted from taxable income.",
      buttonLink: paymentLinks[0],
      showButton: true
    },
    {
      imageSrc: photos[1],
      altText: "SEC 35",
      title: "SEC 35",
      description:
        "Indian businesses and organisations, as well as self-employed, non-salaried individuals can contribute towards scientific research.",
      buttonLink: paymentLinks[1],
      showButton: true
    },
    {
      imageSrc: photos[2],
      altText: "FCRA",
      title: "FCRA",
      description:
        "If you are a foreign source and would like to donate to NCF under FCRA, contact smita@ncf-india.org.",
      additionalText:
        "Please call us or email us if you have any queries. We request your patience with the details the donation forms ask for: they are a legal requirement.",
      buttonLink: "/support",
      showButton: false
    }
  ];

  return (
    <div styleName="wrapper">
      <h2 styleName="header-title">Support Us</h2>
      <div styleName="top-support-container">
        {donationCards.map((card, index) => (
          <DonationCard key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

SupportBanner.propTypes = {
  sectionData: PropTypes.shape({
    paymentLinks: PropTypes.arrayOf(PropTypes.string),
    photos: PropTypes.arrayOf(PropTypes.string)
  })
};

SupportBanner.defaultProps = {
  sectionData: {
    paymentLinks: [],
    photos: []
  }
};

export default SupportBanner;
